<p-toast></p-toast>

<!-- Blocking overlay when loading data -->
@if (isLoadingData()) {
  <div class="blocking-overlay-ground-survey">
    <div class="loading-spinner">
      <i class="pi pi-spin pi-spinner" style="font-size: 3rem; color: #3388ff;"></i>
      <p class="loading-text">{{ 'LOADING_DATA' | translate }}</p>
    </div>
  </div>
}

<div class="request-form-content">
  <div class="uav-layout-content">

    <div class="flex flex-column flex-responsive gap-3">
      <div class="form-side-panels">
      <div class="lg:col-3 md:col-12 sm:col-12">
        <ng-container>
          <!-- First section - Request information -->
          <div class="form-section">
            <div class="field-group">
              <div class="col-5">
                <label class="request-label">{{ 'Request number' | translate }}</label>
              </div>
              <div class="not-edit col-7 ">
                {{ _bid.number }}
              </div>
            </div>

            <div class="field-group ">
              <div class="col-5">
                <label class="request-label">{{ 'Date of creation' | translate }}</label>
              </div>
              <div class="not-edit col-7">
                @if (formData.createAt) {
                  {{ formData.createAt | dateFormatLang:tr.currentLang:true }}
                } @else {
                  {{ '--/--/--  --:--:--' }}
                }
              </div>
            </div>

            <div class="field-group">
              <div class="col-5">
                <label class="request-label">{{ 'Date of update' | translate }}</label>
              </div>
              <div class="not-edit col-7">
                @if (formData.lastUpdateAt) {
                  {{ formData.lastUpdateAt | dateFormatLang:tr.currentLang:true }}
                } @else {
                  {{ '--/--/--  --:--:--' }}
                }
              </div>
            </div>

            <div class="field-group">
              <div class="col-5">
                <label>{{ 'Completion of the survey' | translate }}</label>
              </div>
              <div class="col-7">
                @if (!formData.endDate) {
                  --/--/--
                } @else {
                  {{ formData.endDate | dateFormatLang:tr.currentLang:true }}
                }
              </div>
            </div>


            <div class="field-group ">
              <div class="col-5">
                <label class="request-label">{{ 'Status' | translate }}</label>
              </div>
              <div class="not-edit col-7">
                {{ statusOptions | getById:formData.bidState:'names':tr.currentLang }}
              </div>
            </div>

            <div class="field-group">
              <div class="col-5">
                <label class="request-label">{{ 'BID_WORK_TYPE' | translate }}</label>
              </div>
              <div class="col-7">
                <msf-select-paginated
                  [(model)]="formData.bidWorkType"
                  [service]="bidWorkTypeService"
                  serviceMethod="dictionariesBidWorkTypeGetByQueryPost"
                  optionValue="id"
                  [translateBy]="'names'"
                  searchBy="names"
                  placeholder="{{ 'BID_WORK_TYPE' | translate }}"
                  (modelChange)="onBidWorkTypeChange($event)"
                />
              </div>
            </div>

            <div class="field-group">
              <div class="col-5">
                <label>{{ 'Field' | translate }}</label>
              </div>
              <div class="col-7">
                <msf-select-paginated
                  [(model)]="formData.fieldId"
                  [service]="fieldService"
                  [showClear]="true"
                  (modelChange)="onFieldIdModelChange($event)"
                  (selectItem)="onFieldSelected($event)"
                  (onLoadSelectItem)="onFieldLoaded($event)"
                  [translateBy]="null"
                  serviceMethod="cropMonitoringFieldGetByQueryPost"
                  placeholder="Select field"
                  optionLabel="name"
                  optionValue="id"
                  searchBy="name"
                  [filter]="isAnomalySurveyWorkType() ? anomalySurveyFieldFilters : []"
                  [reload]="fieldSelectReload"
                >
                </msf-select-paginated>
              </div>
            </div>

            @if (isAnomalySurveyWorkType()) {
              <div class="field-group">
                <div class="col-5">
                  <label class="request-label">{{ 'BID_PARENT_SATELLITE_ANOMALY' | translate }}</label>
                </div>
                <div class="col-7">
                  <msf-select-paginated
                    [(model)]="formData.anomalyPolygonId"
                    (modelChange)="onRequiredFieldChange()"
                    [service]="parentAnomalySelectService"
                    serviceMethod="searchSatelliteParentAnomalies"
                    optionLabel="name"
                    optionValue="id"
                    [translateBy]="null"
                    searchBy="name"
                    [showClear]="true"
                    [panelStyle]="{minWidth: '22rem'}"
                    [filter]="parentAnomalyFieldFilters"
                    [reload]="parentAnomalySelectReload"
                    (selectItem)="onParentAnomalySelected($event)"
                    (onLoadSelectItem)="onParentAnomalyOptionLoaded($event)"
                    placeholder="{{ 'BID_PARENT_SATELLITE_ANOMALY_PLACEHOLDER' | translate }}"
                  >
                  </msf-select-paginated>
                </div>
              </div>
            }

            <div class="field-group">
              <div class="col-5">
                <label class="request-label">{{ 'Deadline' | translate }}<span style="color: #ef4444; margin-left: 4px;">*</span></label>
              </div>
              <div class="col-7">
                <app-date-picker
                  [(ngModel)]="formData.deadlineDate"
                  [minDate]="minDeadline()"
                  (click)="deadlineTouched = true"
                  (ngModelChange)="onRequiredFieldChange()"
                  [dateOnly]="true"
                  placeholder="Choose a date">
                </app-date-picker>
                <div *ngIf="(!formData.deadlineDate && deadlineTouched)"
                     class="error-message">{{ 'DeadlineIsRequired' | translate }}.
                </div>

              </div>
            </div>

            <div class="field-group ">
              <div class="col-5">
                <label class="request-label">{{ 'Customer' | translate }}</label>
              </div>
              <div class="col-7">
                <msf-input
                  [(model)]="formData.customer"
                  placeholder="{{ 'Enter customer' | translate }}"
                />
              </div>
            </div>

            <p-divider layout="horizontal"></p-divider>


            <div class="field-group">
              <div class="col-5">
                <label>{{ 'Foreman' | translate }}<span style="color: #ef4444; margin-left: 4px;">*</span></label>
              </div>
              <div class="col-7">
                <msf-select-paginated
                  serviceMethod="loadForemen"
                  optionLabel="label"
                  optionValue="value"
                  searchBy="label"
                  placeholder="{{ 'Select foreman' | translate }}"
                  [(model)]="formData.foremanId"
                  (modelChange)="onRequiredFieldChange()"
                  [service]="notReadyApiService"
                  [translateBy]="null"
                />
                <div *ngIf="!formData.foremanId && foremanTouched"
                     class="error-message">{{ 'ForemanIsRequired' | translate }}
                </div>

              </div>
            </div>

            <div class="field-group">
              <div class="col-5">
                <label>{{ 'Field worker' | translate }}</label>
              </div>
              <div class="not-edit col-7 ">
                {{ workerName || '-' }}
              </div>
            </div>

            @if (bidsToSeasonFlagResolved()) {
              @if (useSeasonCreate()) {
                <div class="field-group">
                  <div class="col-5">
                    <label>{{ 'Season' | translate }}@if (arePlantingFieldsRequired()) {<span style="color: #ef4444; margin-left: 4px;">*</span>}</label>
                  </div>
                  <div class="col-7" [ngClass]="{'p-disabled': !formData.fieldId || seasonsLoading || isSeasonReadOnly()}">
                    <msf-select
                      [(model)]="formData.seasonId"
                      [options]="seasonOptions"
                      optionLabel="name"
                      optionValue="id"
                      [translateBy]="null"
                      optionSubtitle="planFactKey"
                      [panelStyle]="{minWidth: '22rem'}"
                      [showClear]="true"
                      [externalLoading]="seasonsLoading"
                      (modelChange)="onSeasonChange()"
                      (click)="seasonTouched = true"
                      placeholder="Select season"
                    />
                    <div *ngIf="arePlantingFieldsRequired() && !formData.seasonId && seasonTouched" class="error-message">{{ 'SeasonIsRequired' | translate }}.
                    </div>
                    <div *ngIf="arePlantingFieldsRequired() && formData.fieldId && !seasonsLoading && seasonOptions.length === 0" class="error-message">{{ 'NoSeasonsForField' | translate }}.
                    </div>
                  </div>
                </div>

                <div class="field-group">
                  <div class="col-5">
                    <label>{{ 'Crop' | translate }}@if (arePlantingFieldsRequired()) {<span style="color: #ef4444; margin-left: 4px;">*</span>}</label>
                  </div>
                  <div class="col-7 p-disabled">
                    <msf-select-paginated
                      [(model)]="formData.cropId"
                      [service]="cropService"
                      serviceMethod="dictionariesCropGetByQueryPost"
                      searchBy="names"
                      placeholder="Select crop"
                    />
                    <div *ngIf="arePlantingFieldsRequired() && formData.seasonId && !formData.cropId" class="error-message">{{ 'CropIsRequired' | translate }}.
                    </div>
                  </div>
                </div>
              } @else {
                <div class="field-group">
                  <div class="col-5">
                    <label>{{ 'Crop' | translate }}@if (arePlantingFieldsRequired()) {<span style="color: #ef4444; margin-left: 4px;">*</span>}</label>
                  </div>
                  <div class="col-7" [ngClass]="{'p-disabled': !isCrop()}">
                    <msf-select-paginated
                      [(model)]="formData.cropId"
                      [service]="cropService"
                      [showClear]="true"
                      (modelChange)="onCropChange()"
                      (click)="cropTouched = true"
                      serviceMethod="dictionariesCropGetByQueryPost"
                      searchBy="names"
                      placeholder="Select crop"
                    />

                    <div *ngIf="arePlantingFieldsRequired() && !formData.cropId && cropTouched" class="error-message">{{ 'CropIsRequired' | translate }}.
                    </div>
                  </div>
                </div>
              }
            }

            <div class="field-group">
              <div class="col-5">
                <label>{{ 'Sowing date' | translate }}</label>
              </div>
              <div class="col-7">
                <app-date-picker
                  [(ngModel)]="formData.fieldPlantingDate"
                  [maxDate]="today()"
                  placeholder="Choose a date"
                  [dateOnly]="true"
                >
                </app-date-picker>
                @if (isFutureDate(formData.fieldPlantingDate)) {
                  <div class="error-message">{{ 'Unable to select a future date' | translate }}</div>
                }
              </div>
            </div>

            <div class="field-group">
              <div class="col-5">
                <label>{{ 'Variety' | translate }}</label>
              </div>
              <div class="col-7" [ngClass]="{'p-disabled': !isVarietyEnabled}">
                <msf-select-paginated
                  [(model)]="formData.varietyId"
                  [service]="varietyService"
                  serviceMethod="dictionariesVarietyGetByQueryPost"
                  [filter]="varietyFilter"
                  [showClear]="true"
                  searchBy="names"
                  placeholder="{{ 'Select variety' | translate }}"
                />
              </div>
            </div>

          </div>

          <div class="form-section">

            <div class="field-group">
              <div class="col-5">
                <label>{{ 'Author' | translate }}</label>
              </div>
              <div class="p-disabled col-7">
                {{ author || '-/-' }}
              </div>
            </div>

            <div class="field-group ">
              <div class="col-5">
                <label>{{ 'Changed' | translate }}</label>
              </div>
              <div class="p-disabled col-7">
                {{ lastUpdateUser || '-/-' }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <p-divider layout="vertical"></p-divider>
      <div class="lg:col-3 md:col-12 sm:col-12">
        <div class="flex-column">
          <div>
            <div class="mb-2">
              <label>{{ 'Region' | translate }}</label>
            </div>
            <msf-tree-select
              [(model)]="formData.regionId"
              [service]="regionManagerService"
              serviceMethod="getRegionsObservable"
              [placeholder]=" 'Select Region'| translate"
              [showClear]="true"
              [treeBy]="'parentId'"
              (modelChange)="regionChanged()"
            />
          </div>
        </div>
        <div class=" flex-column">
          <div class="mt-3">
            <div class="mb-2">
              <label>{{ 'Latitude' | translate }}<span style="color: #ef4444; margin-left: 4px;">*</span></label>
            </div>
            <msf-input
              [(model)]="formData!.lat"
              (modelChange)="onRequiredFieldChange()"
              (onBlur)="onCoordinatesChange()"
              type="number"
              placeholder="{{'lat' | translate}}"
              step="any"
              [maxFractionDigits]="10"
              class="coordinates-input"
              [disabled]="coordinatesLocked()"
              (click)="latTouched = true"
            />
            <div *ngIf="!coordinatesLocked() && !formData.lat && latTouched" class="error-message"> {{ 'LatitudeIsRequired' | translate }}
            </div>
          </div>
          <div class="mt-3">
            <div class="mb-2">
              <label>{{ 'Longitude' | translate }}<span style="color: #ef4444; margin-left: 4px;">*</span></label>
            </div>
            <msf-input
              [(model)]="formData!.lng"
              (modelChange)="onRequiredFieldChange()"
              (onBlur)="onCoordinatesChange()"
              type="number"
              placeholder="{{'lng' | translate}}"
              step="any"
              [maxFractionDigits]="10"
              [disabled]="coordinatesLocked()"
              (click)="lngTouched = true"
            />
            <div *ngIf="!coordinatesLocked() && !formData.lng && lngTouched" class="error-message">{{ 'LongitudeIsRequired' | translate }}
            </div>
          </div>
        </div>

        <div class="field-group flex flex-column mt-3 align-items-start mt-2">
          <label>{{ 'Task description' | translate }}</label>

          <app-textarea
            class="mt-2"
            placeholder="{{ 'Text' | translate }}"
            [(ngModel)]="formData.description"
          ></app-textarea>
        </div>

        @if (anomalyPolygonLinkId()) {
          <div class="field-group flex align-items-center gap-2 mt-3">
            <span class="request-label">{{ 'BID_ANOMALY_ON_MAP' | translate }}</span>
            <a
              class="p-button p-component p-button-text p-button-sm bid-anomaly-map-link"
              [routerLink]="['/crop-monitoring/anomalies-map']"
              [queryParams]="{ tab: 'map', focusAnomalyId: anomalyPolygonLinkId(), LinkedBidNumber: _bid?.number }"
            >
              <i class="pi pi-map-marker" aria-hidden="true"></i>
            </a>
          </div>
        }

        <!--        <div class="field-group flex   mt-4 flex-column align-items-start">-->
        <!--          <label>{{ 'Task content' | translate }}</label>-->
        <!--          <msf-select-->
        <!--            class="mt-2"-->
        <!--            style="width: 100%;"-->
        <!--            [(model)]="formData.bidTypeId"-->
        <!--            [service]="bidTypeService"-->
        <!--            serviceMethod="dictionariesBidTypeGetByQueryPost"-->
        <!--            placeholder="Task content"-->
        <!--            (click)="bidTypeTouched = true"-->
        <!--          />-->
        <!--          <div *ngIf="!formData.bidTypeId && bidTypeTouched" class="error-message">{{'TaskContentIsRequired' | translate}}.</div>-->
        <!--        </div>-->

        <p-divider layout="horizontal"></p-divider>

        <div class="field-group  mt-4">
          <div class="flex flex-column gap-3 align-items-start">
            <!--            @if (formData.bidState === BidStateType.NUMBER_3) {-->
            <!--              <div>-->
            <!--                <app-checkbox-->
            <!--                  [(ngModel)]="formData.archive"-->
            <!--                  (ngModelChange)="updateLocalBidState()"-->
            <!--                  [label]="'Archive'">-->
            <!--                </app-checkbox>-->
            <!--              </div>-->
            <!--            }-->
            <div>
              <app-checkbox
                [(ngModel)]="formData.publish"
                (ngModelChange)="updateLocalBidState()"
                [label]="'Publish'">
              </app-checkbox>
            </div>
          </div>
        </div>

        @if (formData?.bidState === 3 && formData?.fileResultId) {
          <div class="field-group flex align-items-center">
            <label class="link-label"
                   (click)="downloadBidFile()">{{ 'Survey results' | translate }}
            </label>
            <app-loading
              [width]="'30px'"
              [height]="'30px'"
              [loading]="downloading"
            />
          </div>
        }

        <div class="field-group   mt-4 align-items-start flex flex-column">
          <label>{{ 'Comment' | translate }}</label>
          <app-textarea
            class="mt-2"
            placeholder="{{ 'TEXT' | translate }}"
            [(ngModel)]="formData.comment"
          ></app-textarea>
        </div>
        @if (isAnomalySurveyWorkType()) {
          <div class="field-group mt-4 align-items-start flex flex-column">
            <label>{{ 'BID_ANOMALY_COMMENT' | translate }}</label>
            <app-textarea
              class="mt-2"
              [ngModel]="formData.anomalyComment"
              [disabled]="true"
            ></app-textarea>
          </div>
        }
        <div class="form-actions">
          @if (_bid.bidState !== BidStateType.NUMBER_3 && _bid.bidState !== BidStateType.NUMBER_4 && _bid.bidState !== BidStateType.NUMBER_5)
          {
            <app-secondary-button
              [title]="'Cancel bid'"
              [disable]="isCanceling()"
              [loading]="isCanceling()"
              (action)="cancel.emit()">
            </app-secondary-button>
            <app-save-button
              [disabled]="!formValid()"
              [isSaving]="isSaving()"
              width="auto"
              (save)="saveRequest()">
            </app-save-button>
          }
          @else{
            <div class="col-12 col-md-6" style="padding: 0;">
              <div class="bid-warning">
                {{ "No_Edit_Bid" | translate }}
              </div>
            </div>
          }
        </div>
      </div>
      </div>

      <p-divider layout="vertical"></p-divider>

      <div class="lg:col-5 md:col-12 sm:col-12 map-container">
        <mfs-request-openlayers-map-2
          #groundMap
          appDetectedFieldsLayer
          [height]="'100%'"
          [center]="[this.formData?.lng, this.formData?.lat]"
          [zoom]="14"
          [isCenterMarker]="showMapCenterMarker()"
          (markerClick)="onMarkerClick($event)"
          [multiPolygonJsonColors]="mapPolygons()"
          [(geometry)]="formData.polygon"
          [drawingOptions]="{polygon: false, point: false}"
          [drawingMode]="false"
        ></mfs-request-openlayers-map-2>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showPointModalValue"
     style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 9999; display: flex; align-items: center; justify-content: center;"
     (click)="cancelPointChange()"
>
  <div
    class="map-point-modal-container"
    (click)="$event.stopPropagation()">
    <h3 style="margin: 0 0 15px 0;" class="map-point-modal">{{ 'CHANGE_POINT' | translate }}</h3>
    <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px;">
      <button
        pButton
        type="button"
        severity="secondary"
        [label]=" 'Cancel' | translate"
        (click)="cancelPointChange()"
      ></button>
      <button pButton type="button" label="{{ 'CONFIRM' | translate }}" class="p-button-primary"
              (click)="confirmPointChange()">
      </button>
    </div>
  </div>
</div>

<app-dialog
  [(visible)]="showContinueWithoutFiledDialog"
  header="Confirm"
  width="450px"
  [modal]="true"
  [closable]="true"
  [showFooter]="true"
>
  <div>
    <span>{{ 'Field not found. Continue' | translate }} ? </span>
    <p>{{ 'request.form.auto_fill_forms_disabled' | translate }}.</p>
  </div>
  <ng-template #footer>
    <button pButton type="button" [label]="'No' | translate" class="p-button-text p-button-cancel-btn"
            (click)="notContinueWithoutField()"></button>
    <button pButton type="button" [label]="'Yes' | translate" class="p-button-danger"
            (click)="continueWithoutField()"></button>
  </ng-template>
</app-dialog>

<app-dialog
  [(visible)]="showContinueWithoutVarietyDialog"
  header="Confirm"
  width="450px"
  [modal]="true"
  [closable]="true"
  [showFooter]="true"
>
  <div style="display: flex; align-items: center;">
    <i class="pi pi-question-circle" style="font-size: 3rem; color: var(--red-500); margin-right: 1rem;"></i>
    <span>{{ 'Sowing date not found. Continue' | translate }} ?</span>
  </div>
  <ng-template #footer>
    <button pButton type="button" [label]="'No' | translate" class="p-button-text p-button-cancel-btn"
            (click)="notContinueWithoutField()"></button>
    <button pButton type="button" [label]="'Yes' | translate" class="p-button-danger"
            (click)="continueWithoutField()"></button>
  </ng-template>
</app-dialog>

<app-request-result-modal #requestResultModal></app-request-result-modal>
